import type { FieldSchema, FormPageConfig } from '../types/schema';

function getSampleTextValue(field: FieldSchema): string {
  if (/npi/i.test(field.id)) return '1234567890';
  if (/bin/i.test(field.id)) return '111111';
  if (/zip/i.test(field.id)) return '62701';
  if (/state/i.test(field.id)) return 'IL';
  if (/address_line_1/i.test(field.id)) return '123 Main St';
  if (/address_line_2/i.test(field.id)) return 'Suite 100';
  if (/city/i.test(field.id)) return 'Springfield';
  if (/email/i.test(field.id)) return 'test@example.com';
  if (/medicare/i.test(field.id)) return '1EG4TE5MK73';
  if (/member/i.test(field.id)) return 'MEMBER123';
  if (/group/i.test(field.id)) return 'GROUP123';
  if (/pcn/i.test(field.id)) return 'PCN123';
  if (/phone/i.test(field.id)) return '9495551234';

  if (/lastName|last_name/i.test(field.id)) {
    const now = new Date();
    const timestamp = [
      now.getFullYear().toString(),
      (now.getMonth() + 1).toString().padStart(2, '0'),
      now.getDate().toString().padStart(2, '0'),
      now.getHours().toString().padStart(2, '0'),
      now.getMinutes().toString().padStart(2, '0'),
      now.getSeconds().toString().padStart(2, '0'),
    ].join('');
    const value = `Test-${timestamp}`;
    return field.validation?.maxLength != null ? value.slice(0, field.validation.maxLength) : value;
  }

  return field.validation?.maxLength != null ? 'Test'.slice(0, field.validation.maxLength) : 'Test';
}

export function buildSampleValuesForPage(page: FormPageConfig | undefined): Record<string, unknown> {
  const values: Record<string, unknown> = {};

  if (!page) return values;

  for (const section of page.sections) {
    for (const field of section.fields) {
      if (field.type === 'hidden') continue;

      switch (field.type) {
        case 'text':
          values[field.id] = getSampleTextValue(field);
          break;
        case 'tel':
          values[field.id] = '9495551234';
          break;
        case 'date':
          values[field.id] = '1990-01-01';
          break;
        case 'radio':
        case 'select': {
          const controllingFieldId = field.optionsGroupedBy;
          const options = controllingFieldId
            ? (field.options ?? []).filter((option) => option.group === values[controllingFieldId])
            : (field.options ?? []);
          values[field.id] = options[0]?.value ?? '';
          break;
        }
        case 'multiselect': {
          const controllingFieldId = field.optionsGroupedBy;
          const options = controllingFieldId
            ? (field.options ?? []).filter((option) => option.group === values[controllingFieldId])
            : (field.options ?? []);
          values[field.id] = options[0] ? [options[0].value] : [];
          break;
        }
        case 'textarea':
          values[field.id] = 'Sample text';
          break;
        case 'checkbox':
          values[field.id] = field.checkedValue ?? 'yes';
          break;
        case 'address':
          values[field.id] = {
            addressLine1: '123 Main St',
            addressLine2: '',
            city: 'Springfield',
            state: 'IL',
            zipcode: '62701',
          };
          break;
      }
    }
  }

  return values;
}